import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import CoreScrollUpButton from 'src/core/CoreScrollUpButton/CoreScrollUpButton.vue'

const mountElement = document.querySelector('.vue-mount-scroll-up-button')

if (mountElement) {
  new Vue({
    vuetify,
    el: mountElement,
    components: {
      CoreScrollUpButton,
    },
  })
}
